import { render, staticRenderFns } from "./SendTelegram.vue?vue&type=template&id=0021d020&scoped=true"
import script from "./SendTelegram.vue?vue&type=script&lang=js"
export * from "./SendTelegram.vue?vue&type=script&lang=js"
import style0 from "./SendTelegram.vue?vue&type=style&index=0&id=0021d020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0021d020",
  null
  
)

export default component.exports